const Actions = {
  SET_IS_ROOM_HOST: "SET_IS_ROOM_HOST",
  SET_CONNECT_ONLY_WITH_AUDIO: "SET_CONNECT_ONLY_WITH_AUDIO",
  SET_IDENTITY: "SET_IDENTITY",
  SET_ROOM_ID: "SET_ROOM_ID",
  SET_SHOW_OVERLAY: "SET_SHOW_OVERLAY",
  SET_PARTICIPANTS: "SET_PARTICIPANTS",
  SET_MESSAGES: "SET_MESSAGES",
  SET_ACTIVE_CONVERSATION: 'SET_ACTIVE_CONVERSATION',
  SET_DIRECT_CHAT_HISTORY: 'SET_DIRECT_CHAT_HISTORY',
  SET_SOCKET_ID: 'SET_SOCKET_ID',
  SET_SCREEN_SHARING_USER: 'SET_SCREEN_SHARING_USER',
  SET_IS_SCREEN_SHARING: 'SET_IS_SCREEN_SHARING',
  OPEN_CHAT: "OPEN_CHAT",
  OPEN_PARTICIPANTS: "OPEN_PARTICIPANTS",
  // Authentication actions
  SET_USER: "SET_USER",
  SET_AUTH_ERROR: "SET_AUTH_ERROR",
  SET_AUTH_LOADING: "SET_AUTH_LOADING",
};

export const setIsRoomHost = (isRoomHost) => {
  return {
    type: Actions.SET_IS_ROOM_HOST,
    isRoomHost,
  };
};

export const setConnectOnlyWithAudio = (onlyWithAudio) => {
  return {
    type: Actions.SET_CONNECT_ONLY_WITH_AUDIO,
    onlyWithAudio,
  };
};

export const setIdentity = (identity) => {
  return {
    type: Actions.SET_IDENTITY,
    identity,
  };
};

export const setRoomId = (roomId) => {
  return {
    type: Actions.SET_ROOM_ID,
    roomId,
  };
};

export const setShowOverlay = (showOverlay) => {
  return {
    type: Actions.SET_SHOW_OVERLAY,
    showOverlay,
  };
};

export const setParticipants = (participants) => {
  return {
    type: Actions.SET_PARTICIPANTS,
    participants,
  };
};

export const setMessages = (messages) => {
  return {
    type: Actions.SET_MESSAGES,
    messages,
  };
};

export const setActiveConversation = (activeConversation) => {
  return {
    type: Actions.SET_ACTIVE_CONVERSATION,
    activeConversation
  }
}

export const setDirectChatHistory = (directChatHistory) => {
  return {
    type: Actions.SET_DIRECT_CHAT_HISTORY,
    directChatHistory
  }
}

export const setSocketId = (socketId) => {
  return {
    type: Actions.SET_SOCKET_ID,
    socketId
  }
}

export const setScreenSharingUser = (user) => ({
  type: Actions.SET_SCREEN_SHARING_USER,
  payload: user,
});

export const setIsScreenSharing = (isScreenSharing) => ({
  type: 'SET_SCREEN_SHARING_USER',
  payload: isScreenSharing,
});

export const setIsChatModalOpen = (isChatOpen) => ({
  type: Actions.OPEN_CHAT,
  payload: isChatOpen,
});

export const setIsParticipantsModalOpen = (isParticipantsOpen) => ({
  type: Actions.OPEN_PARTICIPANTS,
  payload: isParticipantsOpen,
});

// Authentication actions
export const setUser = (user) => {
  return {
    type: Actions.SET_USER,
    payload: user,
  };
};

export const setAuthError = (error) => {
  return {
    type: Actions.SET_AUTH_ERROR,
    payload: error,
  };
};

export const setAuthLoading = (loading) => {
  return {
    type: Actions.SET_AUTH_LOADING,
    payload: loading,
  };
};

export default Actions;
